import {
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';
import * as React from 'react';

export interface IFollowButtonModalProps {
  isOpen: boolean;
  onClose: () => void;
  organizationName: string;
  onSubmit: (isConsented: boolean) => void;
}

export const FollowButtonModal = (props: IFollowButtonModalProps) => {
  return (
    <Modal
      isOpen={props.isOpen}
      onClose={props.onClose}
      size={{ base: 'full', md: 'lg' }}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton />
        <ModalHeader
          aria-label={'Follow'}
          display="flex"
          flexDirection="column"
          alignItems="center"
          pb="1"
        >
          We Value Your Privacy
        </ModalHeader>
        <ModalBody pt="1" px="6" pb="6">
          <Text color="gray.600" textAlign="center" mb="5">
            By clicking “I Agree”, you consent to sharing your contact details
            (name, email, phone number) with the specified sponsor(s). They may
            use this information to provide you with updates, offers, and
            service-related communication. Your data will only be shared with
            these sponsor(s) you follow.
          </Text>
        </ModalBody>
        <ModalFooter borderTop="1px" borderTopColor="gray.100">
          <Flex justify={'space-between'} w={'100%'}>
            <Button
              variant="outline"
              colorScheme="gray"
              type="button"
              id="agreeToConsent"
              onClick={props.onClose}
            >
              Decline
            </Button>
            <Button
              type="button"
              id="agreeToConsent"
              onClick={() => {
                props.onSubmit(true);
              }}
            >
              I Agree
            </Button>
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
